import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'test',
    template: require('./partials/test.html'),
})
export class TestComponent {
  
  test2 = '<b>This is shared</b>';

  constructor() {
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/test.component.ts